import React, { FC, Fragment } from 'react';

import { UserGroup } from 'types/app';
import { NULL } from 'constants/index';

import { IChunkedResult } from '../types';
import Page from './Page';

interface IProps {
  chunkedResults: IChunkedResult[];
  onLoadMoreRows: () => void;
  selectedGroup?: UserGroup;
}

const PageHandler: FC<IProps> = props => {
  const { chunkedResults, selectedGroup, onLoadMoreRows } = props;

  function getPageEl(index: number) {
    return document.querySelector(`div[data-page-index="${index}"]`);
  }

  function showPage(index: number) {
    // TODO: Temporary
    return;

    const targetPage = getPageEl(index);
    if (!targetPage) {
      return;
    }

    targetPage.removeAttribute('style');
    targetPage.firstElementChild.removeAttribute('hidden');
  }

  function hidePage(index: number) {
    // TODO: Temporary
    return;

    const targetPage = getPageEl(index);
    if (!targetPage) {
      return;
    }

    const { clientHeight } = targetPage;
    targetPage.setAttribute('style', `height: ${clientHeight}px`);
    targetPage.firstElementChild.setAttribute('hidden', 'true');
  }

  function handleResults(pageIndex: number) {
    showPage(pageIndex - 1);
    hidePage(pageIndex + 1);
  }

  async function handleRequest(pageIndex: number) {
    const requestIndex = pageIndex + 1;
    const hideIndex = pageIndex - 1;

    if (chunkedResults[requestIndex]) {
      showPage(requestIndex);
      hidePage(hideIndex);
      return;
    }

    await onLoadMoreRows();
    hidePage(hideIndex);
  }

  function renderPage(chunkedResult: IChunkedResult, pageIndex: number) {
    const { results } = chunkedResult;

    return (
      <div key={pageIndex} data-page-index={pageIndex}>
        <div>
          <Page
            results={results}
            selectedGroup={selectedGroup}
            onRequest={() => handleRequest(pageIndex)}
            onResults={() => handleResults(pageIndex)}
          />
        </div>
      </div>
    );
  }

  return <Fragment>{chunkedResults.map(renderPage)}</Fragment>;
};

PageHandler.defaultProps = {
  selectedGroup: NULL,
};

export default PageHandler;
